var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09937 3.55V18.85C6.09937 19.5263 6.36803 20.1749 6.84624 20.6531C7.32446 21.1313 7.97306 21.4 8.64937 21.4H18.8494C19.5257 21.4 20.1743 21.1313 20.6525 20.6531C21.1307 20.1749 21.3994 19.5263 21.3994 18.85V7.68355C21.3993 7.34384 21.3314 7.00756 21.1996 6.69446C21.0678 6.38136 20.8748 6.09776 20.6318 5.8603L16.4052 1.72675C15.9288 1.26094 15.289 1.00008 14.6227 1H8.64937C7.97306 1 7.32446 1.26866 6.84624 1.74688C6.36803 2.2251 6.09937 2.8737 6.09937 3.55Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 21.4V23.95C16.3 24.6263 16.0313 25.2749 15.5531 25.7531C15.0749 26.2313 14.4263 26.5 13.75 26.5H3.55C2.8737 26.5 2.2251 26.2313 1.74688 25.7531C1.26866 25.2749 1 24.6263 1 23.95V9.925C1 9.2487 1.26866 8.6001 1.74688 8.12188C2.2251 7.64366 2.8737 7.375 3.55 7.375H6.1",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.fc3577d2855dbf250277a049269fabd8.svg";
export { ForwardRef as ReactComponent };